import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";
import VolunteerRegisterTable from "../../components/Volunteer/VolunteerRegisterTable";

const VolunteerRegisterPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Volunteer Register</VolunteerHeading>
      <VolunteerRegisterTable></VolunteerRegisterTable>
    </MainDiv>
  );
};

export default VolunteerRegisterPage;
